import { css } from "@linaria/core";
import React from "react";
import { colors } from "@ui/Theme";
import { fonts } from "@ui";
import { analysisTitleNoDate } from "../../../Analysis/analysisTitle";
import formatDate from "@ui/i18n/formatDate";

const analysisDate = css`
  font: ${fonts.body1};
  color: ${colors.carbon700};
`;
export const AnalysisDateChartTooltip = ({
  date,
  group,
  label,
  timezone,
}: {
  label: string | null;
  group: string | null;
  date: number;
  timezone: string;
}) => {
  const analysisDateStr = analysisTitleNoDate({ group, label });

  return (
    <div className={analysisDate}>
      <p>{analysisDateStr}</p>
      <p>{formatDate(date, "datetime", timezone)}</p>
    </div>
  );
};
